<template>
  <el-dialog :title="title" append-to-body modal="false" :visible.sync="visible" :before-close="handleClose">
    <div class="warp">
      <template v-if="fileList.length">
        <div v-loading="loading" v-for="(file,i) in fileList" :key="i">
          <item :file="file" isVersion @on-view="handleView" @on-down="handleDownload" />
        </div>
      </template>
      <el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import item from './item.vue'
export default {
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    title: {
      type: String,
      default: '历史版本'
    },
    currentfile: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    item
  },
  data() {
    return {
      fileList: [],
      fileVersion: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,

      loading: false
    }
  },
  watch: {
    pageNum(val) {
      this.queryVersionServe({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
    },
    pageSize(val) {
      this.queryVersionServe({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
    }
  },
  mounted() {
    this.queryVersionServe({
      pageNum: this.pageNum,
      pageSize: this.pageSize
    })
  },
  methods: {
    handleView(file) {
      this.$emit('on-view', file)
    },
    handleDownload(file) {
      this.$emit('on-down', file)
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    },
    handleSizeChange(size) {
      this.pageSize = size
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage
    },
    async queryVersionServe(params) {
      try {
        this.loading = true
        const {
          fileUniqueCode
        } = this.currentfile
        const body = {
          'entity': {
            fileUniqueCode
          },
          'orderItemList': [
            {
              'asc': false,
              'column': 'version'
            }
          ]
        }
        const { data, code } = await this.$http.post('/common/document/query-his-version', body, {
          params
        })

        if (code === 200) {
          this.loading = false
          const {
            records,
            total
          } = data

          this.total = total

          this.fileList = records
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__body) {
  border-top: 1px solid #ebeef5;
  padding: 0;
}
.empty {
  text-align: center;
  padding: 50px;
}
.warp {
  padding: 20px;
  height: 600px;
  overflow: auto;
}
</style>
